<template>
  <div class="border border-surface-200 dark:border-surface-700 rounded-lg overflow-hidden">
    <div class="px-4 py-2 border-b border-surface-200 dark:border-surface-700 text-sm">
      <span class="text-surface-500">{{ t('mail_subject') }}:</span>
      <span class="font-medium ml-1">{{ subject }}</span>
    </div>
    <div class="relative bg-surface-50 dark:bg-surface-900">
      <div v-if="loading" class="absolute inset-0 flex items-center justify-center bg-surface-0/60 dark:bg-surface-900/60">
        <ProgressSpinner class="!size-8" strokeWidth="5" />
      </div>
      <p v-if="error" class="m-0 p-6 text-surface-600 dark:text-surface-300">{{ t('mail_campaign_preview_failed') }}</p>
      <!-- sandbox without allow-scripts: the rendered mail is shown, never run -->
      <iframe v-else :srcdoc="html" sandbox="" :title="t('mail_campaign_preview')" class="block w-full h-[36rem] border-0 bg-white" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';

defineProps<{ html: string; subject: string; loading?: boolean; error?: boolean }>();
const { t } = useI18n();
</script>
